import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import RelatorioBeneficiariosApi from '../../api/RelatorioBeneficiariosApi';
import AlertDialogSlide from '../share/AlertDialogSlide';

const styles = theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  button: {
    margin: theme.spacing(1),
  },
});

class ToolbarBeneficiarioSelect extends React.Component {
  beneficiarioApi = new RelatorioBeneficiariosApi();
  state = {
    openDialog: false,
  }

  handleClickGerar = () => {
    this.setState({ openDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleDialogConfirm = async () => {
    this.setState({ openDialog: false });
    this.props.handleClickToolBar();

    const beneficiarios = [];
    for (var i = 0; i < this.props.selectedRows.data.length; i++) {
      beneficiarios.push(this.props.displayData[this.props.selectedRows.data[i].index].data[1]);
    }

    let nomeArquivo = '';
    if (this.props.tipoArquivo === 1) {
      nomeArquivo = 'inclusao_beneficiarios.txt';
    } 
    if (this.props.tipoArquivo === 2) {
      nomeArquivo = 'exclusao_beneficiarios.txt';
    }    
    if (this.props.tipoArquivo === 3) {
      nomeArquivo = 'alteracao_beneficiarios.txt';
    }    

    const fileContent = await this.beneficiarioApi.gerarArquivoCaixaTitulares(beneficiarios, this.props.tipoArquivo);    
    // await this.gerarArquivo(nomeArquivo, fileContent);
    this.gerarArquivoANSI(nomeArquivo, fileContent);


    if (this.props.tipoArquivo === 1) {
      nomeArquivo = 'inclusao_beneficiarios_dep.txt';
    } 
    if (this.props.tipoArquivo === 2) {
      nomeArquivo = 'exclusao_beneficiarios_dep.txt';
    }    
    if (this.props.tipoArquivo === 3) {
      nomeArquivo = 'alteracao_beneficiarios_dep.txt';
    }    

    const fileContentDep = await this.beneficiarioApi.gerarArquivoCaixaDependentes(beneficiarios, this.props.tipoArquivo);
    // await this.gerarArquivo(nomeArquivo, fileContentDep);
    this.gerarArquivoANSI(nomeArquivo, fileContentDep);

    this.props.setSelectedRows([]);
    await this.props.onOperacaoFinalizada();
  };

  gerarArquivo = async (nomeArquivo, fileContent) => {
    let conteudo = '';
    const encoding = 'windows-1252';

    for (var i = 0; i < fileContent.length; i++) {
      conteudo = conteudo + fileContent[i].nome + '\n';
    }

    const utf8_blob = new Blob( [conteudo], { endings: "native" } );
    const utf_8_txt = await utf8_blob.text();
    const encoder = new TextEncoder(encoding, {
      NONSTANDARD_allowLegacyEncoding: true
    });
    const data = encoder.encode(utf_8_txt); 
    const encoded_as_ANSI = new Blob([data]);

    const url = window.URL.createObjectURL(encoded_as_ANSI);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }

  gerarArquivoANSI = (nomeArquivo, fileContent) => {
    let conteudo = '';

    for (var i = 0; i < fileContent.length; i++) {
      conteudo = conteudo + fileContent[i].nome + '\n';
    }
    const url = window.URL.createObjectURL(new Blob([conteudo]), {type: 'text/plain;charset=ANSI'});
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }  

  render () {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div className={classes.root}>
          <Button
            variant='contained'
            className={classes.button}
            onClick={this.handleClickGerar}
            color='primary'
            size='small'
            title='Gerar Arquivos'>
            Gerar Arquivos
          </Button>
        </div>
        <AlertDialogSlide
          open={this.state.openDialog}
          handleClose={this.handleCloseDialog}
          handleClick={this.handleDialogConfirm}
          title={'Gerar arquivos...'}
          message={`${this.props.selectedRows.data.length}
                    beneficiário(s) selecionado(s). Deseja gerar os arquivos de Titulares e Dependentes?`} />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ToolbarBeneficiarioSelect);
